const PREFIX = 'LOCATION_EQUIPMENT/';

export const LOCATION_EQUIPMENT_LIST = `${PREFIX}LIST`;
export const SET_SELECTED_LOCATION_EQUIPMENT = `${PREFIX}SET_SELECTED_EQUIPMENT`;
export const SET_SELECTED_LOCATION = `${PREFIX}SET_SELECTED_LOCATION`;
export const LOCATION_EQUIPMENT_REFRESH = `${PREFIX}REFRESH`;
export const LOCATION_EQUIPMENT_REFRESH_ALL = `${PREFIX}REFRESH_ALL`;
export const LOCATION_EQUIPMENT_RESTART = `${PREFIX}RESTART`;
export const LOCATION_EQUIPMENT_RESTART_ALL = `${PREFIX}RESTART_ALL`;
export const START_POLLING = `${PREFIX}START_POLLING`;
export const STOP_POLLING = `${PREFIX}STOP_POLLING`;
